import { Action, createReducer, on } from '@ngrx/store';

import * as productSolution from '../actions';
import { Item } from '../models/product-solutions.model';
export const addProductSolutionFeatureKey = 'addProductSolution';

export interface State {
  loaded: boolean;
  error?: Error | any;
  addedProductSolution: string;
  saveSelectedProductSolution: Item;
}

export const initialState: State = {
  loaded: false,
  error: undefined,
  addedProductSolution: undefined,
  saveSelectedProductSolution: undefined
};

export const reducer = createReducer(
  initialState,
  on(
    productSolution.loadAddProductSolutions,

    state => state
  ),
  on(productSolution.loadAddProductSolutionssSucces, (state, action) => ({
    ...state,
    addedProductSolution: action.response,
    loaded: true
  })),

  on(productSolution.loadAddProductSolutionssFailure, (state, { error }) => ({
    ...state,
    error
  })),
  on(productSolution.loadSaveProductSolutions, (state, action) => ({
    ...state,
    saveSelectedProductSolution: action.save
  }))
);

export const selectAddProductSolutions = (state: State) => state.addedProductSolution;
export const selectAddProductSolutionsLoaded = (state: State) => state.loaded;
export const selectAddProductSolutionsError = (state: State) => state.error;

export const selectSavedProductSolutions = (state: State) => state.saveSelectedProductSolution.productSolutionsId;

/** Full list row saved when opening edit (includes canDelete from get product solutions). */
export const selectSaveSelectedProductSolutionItem = (state: State) => state.saveSelectedProductSolution;
